import {Grid} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import styles from 'assets/jss/Report/ReportStyle';
import SelectBox from './SelectBox';

const useStyles = makeStyles(styles);

const Header = ({selectedDay}) => {
    const classes = useStyles();
    return (
        <Grid container className={classes.filterDaysContainer}>
            <Grid item className={classes.filterDaysText} xs={6.5}>
                <span className={classes.boldTitleChoices}>نمایش گزارش از تاریخ امروز تا:</span>
            </Grid>
            <Grid item display='flex' justifyContent='end' xs={5.5}>
                <SelectBox onChaneHandler={selectedDay}/>
            </Grid>
        </Grid>
    );
};

export default Header;
